import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, Typography, CircularProgress, Box, Grid, Button, Chip, CardActions, 
  Divider, Dialog, DialogTitle, DialogContent, IconButton, DialogActions } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BusinessIcon from '@mui/icons-material/Business';
import WorkIcon from '@mui/icons-material/Work';
import LanguageIcon from '@mui/icons-material/Language';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Organizationapplied, OrganizationapplyjobDetails } from "../../../../../helper/base_url";

const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case 'accepted':
      return 'warning';
    case 'pending':
       return 'error';
    case 'rejected':
      return 'error';
    default:
      return 'default';
  }
};

const AppliedJobsList = () => {
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJobDetails, setSelectedJobDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchAppliedJobs = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${Organizationapplied}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      //console.log('Fetched job details hired:', response.data.data);
      return response.data;
    } catch (error) {
      //console.error('Error fetching applied jobs:', error);
      //throw error;
    }
  };
  const fetchJobDetails = async (hiringId) => {
    try {
      setDetailsLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${OrganizationapplyjobDetails}/${hiringId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      //console.log('Fetched job details:', response.data.data);
      setSelectedJobDetails(response.data.data);
      setModalOpen(true);
    } catch (error) {
      //console.error('Failed to fetch job details:', error);
    } finally {
      setDetailsLoading(false);
    }
  };

  useEffect(() => {
    const loadAppliedJobs = async () => {
      try {
        const response = await fetchAppliedJobs();
        setAppliedJobs(response.data);
      } catch (error) {
        //console.error('Failed to fetch applied jobs:', error);
      } finally {
        setLoading(false);
      }
    };

    loadAppliedJobs();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={6}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (appliedJobs.length === 0) {
    return (
      <Typography variant="h6" align="center" mt={6}>
        No applied Lists found.
      </Typography>
    );
  }

  return (
    <Box p={3} width="100%">
      <Typography variant="h2" gutterBottom fontSize="1.4rem">
        My Applied Lists
      </Typography>
     <Grid container spacing={4} mt={2}>
      {appliedJobs.map((job, i) => (
      <Grid item xs={12} sm={6} md={6} key={i}>
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 4,
            height : '100%',
            display: 'flex',
            flexDirection: 'column',
            transition: 'transform 0.3s ease',
            '&:hover': { transform: 'translateY(-6px)', boxShadow: 6 },
          }}
        >
          <CardContent sx={{ flexGrow: 1, px: 3, py: 2 }}>
            <Typography
              variant="subtitle2"
              color="primary"
              fontWeight={600}
              gutterBottom
              sx={{ textTransform: 'uppercase', letterSpacing: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}
            >
              <BusinessIcon fontSize="small" />
              {job.company}
            </Typography>

            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <WorkIcon fontSize="small" />
              {job.title}
            </Typography>

            <Typography variant="body2" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <LanguageIcon fontSize="small" />
              <a
                href={job.website?.startsWith('http') ? job.website : `https://${job.website}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#1976d2', fontWeight: 500, textDecoration: 'none' }}
                onMouseEnter={e => (e.target.style.textDecoration = 'underline')}
                onMouseLeave={e => (e.target.style.textDecoration = 'none')}
              >
                {job.website}
              </a>
            </Typography>

            <Divider sx={{ my: 2 }} />
             {/* <Chip
                  label={job.statusOfApplication.toLowerCase() === 'accepted' ? 'In Review' : job.statusOfApplication}
                  color={getStatusColor(job.statusOfApplication)}
                  // color={job.statusOfApplication.toLowerCase() === 'accepted' ? 'warning' : getStatusColor(job.statusOfApplication)}
                  size="small"
                  sx={{ mb: 1 }}
                />
              <Typography variant="subtitle2" color="text.secondary">
              {job.ishired ? 'Hired' : 'In Review'}
            </Typography> */}
            <Chip
              icon={job.ishired ? <CheckCircleIcon /> : undefined}
              label={
                job.ishired
                  ? 'Hired'
                  : job.statusOfApplication.toLowerCase() === 'accepted'
                  ? 'In Review'
                  : job.statusOfApplication
              }
              color={job.ishired ? 'success' : getStatusColor(job.statusOfApplication)}
              size="small"
              sx={{ mb: 2, fontWeight: 600, px: 1.5 }}
            />
            <Typography variant="body2" color="text.secondary">
              Applied on: {new Date(job.appliedDate).toLocaleDateString()}
            </Typography>
          </CardContent>

          <CardActions sx={{ justifyContent: 'flex-end', px: 3, pb: 2 }}>
            <Button variant="outlined" size="small" onClick={() => fetchJobDetails(job.hiringId)}>
              View Details
            </Button>
          </CardActions>
        </Card>
      </Grid>
      ))}
      </Grid>
      {/* Job Details Dialog */}
      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="md" fullWidth>
    <DialogTitle
        sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
    >
        Details
        <IconButton
        aria-label="close"
        onClick={() => setModalOpen(false)}
        sx={{
            color: (theme) => theme.palette.grey[500],
        }}
        >
        <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {detailsLoading ? (
        <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress />
        </Box>
        ) : selectedJobDetails ? (
        <>
            <Typography variant="h6" gutterBottom>
            {selectedJobDetails.hiringPost.opportunityOverview.title}
            </Typography>
             {/* Hired Status at the top */}
            <Box display="flex" justifyContent="flex-start" mb={2}>
            <Chip
              label={selectedJobDetails.isHired ? 'Hired' : 'Not Hired'}
              color={selectedJobDetails.isHired ? 'success' : 'warning'}
              variant="outlined"
              sx={{
                fontSize: '1.4rem',
                fontWeight: 600,
                px: 1.5, 
                py: 0.5, 
              }}
            />
            </Box>
            <Typography variant="subtitle1">
            {selectedJobDetails.hiringPost.opportunityOverview.opportunityType} — {selectedJobDetails.hiringPost.opportunityOverview.location}
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body2" gutterBottom>
            <strong>Domain:</strong> {selectedJobDetails.hiringPost.roleDetails.domain.join(', ')}
            </Typography>
            <Typography variant="body2" gutterBottom>
            <strong>Responsibilities:</strong> {selectedJobDetails.hiringPost.roleDetails.responsibilities}
            </Typography>
            <Typography variant="body2" gutterBottom>
            <strong>Skills Required:</strong> {selectedJobDetails.hiringPost.roleDetails.skills.join(', ')}
            </Typography>
            <Typography variant="body2" gutterBottom>
            <strong>Deliverables:</strong> {selectedJobDetails.hiringPost.roleDetails.deliverables}
            </Typography>
            <Typography variant="body2" gutterBottom>
            <strong>Stipend/Salary:</strong> {selectedJobDetails.hiringPost.compensationAndDates.stipendOrSalary}
            </Typography>
            <Typography variant="body2" gutterBottom>
            <strong>Application Deadline:</strong> {new Date(selectedJobDetails.hiringPost.compensationAndDates.applicationDeadline).toLocaleDateString()}
            </Typography>
            <Typography variant="body2" gutterBottom>
            <strong>Joining Date:</strong> {new Date(selectedJobDetails.hiringPost.compensationAndDates.joiningDate).toLocaleDateString()}
            </Typography>
           {/* <Typography variant="body2" gutterBottom>
              <strong>Hired Status:</strong> {selectedJobDetails.isHired ? 'Hired' : 'not Hired'}
           </Typography> */}
        </>
        ) : (
        <Typography>No details available.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setModalOpen(false)}>Close</Button>
      </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AppliedJobsList;
